
import axioPath from '../../../api/axioPath';
import { showAppLoader, hideAppLoader } from '../app';


export const setCurrentLanguage = (value) => ({
  type: "CURRENT_LANGUAGE",
  payload: value,
});

export const fetchLanguageContent = (value) => (dispatch) => {
  let securityKey = 'RaMrAjV0VHJhZGVyQDIwMjI='
  dispatch(showAppLoader());
  return axioPath.get(`language/getAllContent?language=${value}`, {
    headers: {
      secretKey: securityKey,
    },
  }).then((response) => {
    dispatch(hideAppLoader());
      dispatch({ type: "LANGUAGE_CONTENT", payload: Object.keys(response.data.payload).length === 0 ? [] : response.data.payload });
    })
    .catch(() => {
      dispatch(hideAppLoader());
    });
};

// updated api for language localization
export const fetchLanguageContentNew = (value) => (dispatch) => {
  let securityKey = 'RaMrAjV0VHJhZGVyQDIwMjI='
  dispatch(showAppLoader());
  return axioPath.get(`/user/language/getContent?language=${value}`, {
    headers: {
      secretKey: securityKey,
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    dispatch({ type: "LANGUAGE_CONTENT_NEW", payload: Object.keys(response.data.payload).length === 0 ? [] : response.data.payload });
  }).catch(() => {
    dispatch(hideAppLoader());
    });
};
